export default __webpack_public_path__ + "static/media/login-bg.7dd41f69.jpg";